import { useState, useEffect } from 'react';
import './App.css';


function App() {

  const [inputName, setInputName] = useState('');
  const [inputDate, setInputDate] = useState(''); 

  function handleName(e) {
    setInputName(e.target.value);
  }

  function handleDate(e) {
    setInputDate(e.target.value);
  }

  function handleRefresh() {
    window.location.reload();
  } 

  useEffect( ()=> {
    if (inputName === '') {
      setInputName('Enter Name');
    }
    if (inputDate === '') {
      setInputDate('Enter Date');
    }

    console.log('Name: ' + inputName);
  }, [] )


  return (
    <div className="container">
      <h1>Dynamic React Input Example</h1>
      <label>Name:</label>
      <input type="text" name="text" value={inputName} placeholder='Enter Name' onInput={handleName} />
      <label>Date:</label>
      <input type="date" name="date" onChange={handleDate} />

      <h2>{inputName}</h2>
      <h2>{inputDate}</h2>

      <p>Simple dynamic example of live input values</p>

      <button className='btn' onClick={handleRefresh}>Refresh Page</button>
    </div>
  );
}

export default App;
